﻿(function () {
    'use strict';

    angular.module('app').config(['$translateProvider', 'tmhDynamicLocaleProvider', 'config',
        function ($translateProvider, tmhDynamicLocaleProvider, config) {

            $translateProvider.useStaticFilesLoader({
                files: [
                    {
                        prefix: 'app/resources/error/error-',
                        suffix: '.json'
                    },
                    {
                        prefix: 'app/resources/login/login-',
                        suffix: '.json'
                    },
                    {
                        prefix: 'app/resources/dashboard/dashboard-',
                        suffix: '.json'
                    },
                    {
                        prefix: 'app/resources/appointment/appointment-',
                        suffix: '.json'
                    },
                    {
                        prefix: 'app/resources/appointmentScheduler/appointmentScheduler-',
                        suffix: '.json'
                    },
                    {
                        prefix: 'app/resources/appointmentSearch/appointmentSearch-',
                        suffix: '.json'
                    },
                    {
                        prefix: 'app/resources/header/header-',
                        suffix: '.json'
                    },
                    {
                        prefix: 'app/resources/dirmenubar/dirmenubar-',
                        suffix: '.json'
                    },
                    {
                        prefix: 'app/resources/equipmentTrackingSearch/equipmentTrackingSearch-',
                        suffix: '.json'
                    },
                    {
                        prefix: 'app/resources/truckTrackingSearch/truckTrackingSearch-',
                        suffix: '.json'
                    },
                    {
                        prefix: 'app/resources/equipmentDamageSearch/equipmentDamageSearch-',
                        suffix: '.json'
                    },
                    {
                        prefix: 'app/resources/eirSearch/eirSearch-',
                        suffix: '.json'
                    },
                    {
                        prefix: 'app/resources/report/progressdepotorder-',
                        suffix: '.json'
                    },
                    {
                        prefix: 'app/resources/report/equipmentstock-',
                        suffix: '.json'
                    },
                    {
                        prefix: 'app/resources/report/containerreception-',
                        suffix: '.json'
                    },
                    {
                        prefix: 'app/resources/report/inspectiontime-',
                        suffix: '.json'
                    },
                    {
                        prefix: 'app/resources/report/stocksummary-',
                        suffix: '.json'
                    },
                    {
                        prefix: 'app/resources/report/repairtime-',
                        suffix: '.json'
                    },
                    {
                        prefix: 'app/resources/report/longstanding-',
                        suffix: '.json'
                    },
                    {
                        prefix: 'app/resources/report/progressdepotorderdetail-',
                        suffix: '.json'
                    },
                    {
                        prefix: 'app/resources/report/gateoperationinventory-',
                        suffix: '.json'
                    },
                    {
                        prefix: 'app/resources/report/oos-',
                        suffix: '.json'
                    },
                    {
                        prefix: 'app/resources/report/dryreefer-',
                        suffix: '.json'
                    },
                    {
                        prefix: 'app/resources/report/serviceTime-',
                        suffix: '.json'
                    },
                    {
                        prefix: 'app/resources/report/serviceTimeShipper-',
                        suffix: '.json'
                    }
                ]
            });

            $translateProvider.preferredLanguage(config.defaultLanguage);
            $translateProvider.useSanitizeValueStrategy('escaped');
            $translateProvider.fallbackLanguage(config.defaultLanguage);
            $translateProvider.useLocalStorage();

            tmhDynamicLocaleProvider.localeLocationPattern('app/resources/i18n/angular-locale_{{locale}}.js');
            tmhDynamicLocaleProvider.useCookieStorage();
        }]);

})();